import React from 'react'
import { Component } from 'reflux'
import { toast } from 'react-toastify'
import { SubProductGroupActions, SubProductGroupStore, STATUS } from 'Stores/subProductGroupStore'
import SubProductGroupForm from 'Modules/subProductGroup/subProductGroupForm'

export default class SubProductGroupCreate extends Component {
  constructor(props) {
    super(props)
    this.stores = [SubProductGroupStore]
    this.storeKeys = ['status']
  }
  componentDidMount() {
    SubProductGroupActions.createEmptySubProductGroup()
  }
  componentDidUpdate() {
    if (this.state.status === STATUS.UPDATE_SUCCESS) {
      toast.success('SubProductGroup Created', {
        autoClose: 3000,
        onClose: () => {
          SubProductGroupActions.clearFormToast()
        }
      })
      SubProductGroupActions.clearFormToast(STATUS.REDIRECT)
    }
    if (this.state.status === STATUS.UPDATE_ERROR) {
      toast.error('SubProductGroup Create Failed', {
        autoClose: 3000,
        onClose: () => {
          SubProductGroupActions.clearFormToast()
        }
      })
      SubProductGroupActions.clearFormToast(STATUS.REDIRECT)
    }
  }

  render() {
    return (
      <React.Fragment>
        <SubProductGroupForm />
      </React.Fragment>
    )
  }
}
